module.exports = __webpack_public_path__ + "static/media/sage.2e571e03.png";